import { render } from "./DetaljiSuvenir.vue?vue&type=template&id=501356d6&scoped=true"
import script from "./DetaljiSuvenir.vue?vue&type=script&lang=js"
export * from "./DetaljiSuvenir.vue?vue&type=script&lang=js"

import "./DetaljiSuvenir.vue?vue&type=style&index=0&id=501356d6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501356d6"]])

export default __exports__